import classNames from "classnames";
import PropTypes from "prop-types";

import classes from "./checkbox.module.scss";

function Checkbox({
  name,
  label,
  isEnabled,
  isChecked,
  className,
  style,
  onClick,
}) {
  return (
    <label
      className={classNames(classes.checkbox, className, {
        [classes.disabled]: !isEnabled,
      })}
      style={style}
    >
      <div className={classes.wrapper}>
        {isChecked && <img src={"/images/icons/checkmark.svg"} alt="Check" />}

        <input
          type="checkbox"
          name={name}
          checked={isChecked}
          onChange={onClick}
          disabled={!isEnabled}
        />
      </div>

      {label && <span className={classes.label}>{label}</span>}
    </label>
  );
}

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  isEnabled: PropTypes.bool.isRequired,
  isChecked: PropTypes.bool.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

Checkbox.defaultProps = {
  name: "",
  isEnabled: false,
  isChecked: false,
};

export default Checkbox;
